import {
    apiRequest,
    processInput
} from "@/utilities"

export const languageService = {
    async getLanguages() {
        const getLanguagesRequest = {
            method: "GET"
        }
        return await apiRequest("/api/languages", getLanguagesRequest)
    },
    async getLanguage(uuid) {
        const getLanguageRequest = {
            method: "GET"
        }
        return await apiRequest(`/api/languages/${uuid}`, getLanguageRequest)
    },
    async createLanguage(params) {
        const createLanguageRequest = {
            method: "POST",
            data: processInput(params)
        }
        return await apiRequest("/api/languages", createLanguageRequest)
    },
    async editLanguage(params) {
        const { uuid } = params
        delete params.uuid
        let data = processInput(params)
        data.append("_method", "PATCH");
        const editLanguageRequest = {
            method: "POST",
            data
        }
        return await apiRequest(`/api/languages/${uuid}`, editLanguageRequest)
    },
    async deleteLanguage(uuid) {
        const deleteLanguageRequest = {
            method: "DELETE"
        }
        return await apiRequest(`/api/languages/${uuid}`, deleteLanguageRequest)
    }
}